import "core-js/modules/es.function.name";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "C:/projects/michelin-hp/node_modules/@babel/runtime/helpers/asyncToGenerator";
import { axiosInstance } from 'boot/axios.js';
export function get(_x) {
  return _get.apply(this, arguments);
}

function _get() {
  _get = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(ctx) {
    var queryParams,
        id,
        response,
        modules,
        warranty,
        _args = arguments;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            queryParams = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
            _context.prev = 1;
            id = queryParams.id;
            delete queryParams.id;
            _context.next = 6;
            return axiosInstance({
              url: parseUrl('tyres/' + id, queryParams),
              params: queryParams,
              method: 'GET'
            });

          case 6:
            response = _context.sent;
            _context.next = 9;
            return axiosInstance({
              url: parseUrl('app-modules', {
                filters: 'where[category]=BFGOODRICH'
              }),
              params: {
                sort: 'order desc',
                'filters[where][type][eq]': 'TYRE_DETAIL',
                'filters[where][status][eq]': 'PUBLISHED',
                'filters[where][name][eq]': response.data.name,
                'filters[where][category][eq]': response.data.brand.toUpperCase(),
                limit: 1000
              },
              method: 'GET'
            });

          case 9:
            modules = _context.sent;
            _context.next = 12;
            return axiosInstance({
              url: parseUrl('app-modules', {}),
              params: {
                sort: 'order desc',
                'filters[where][type][eq]': 'WARRANTY',
                'filters[where][status][eq]': 'PUBLISHED',
                'filters[where][category][eq]': response.data.brand.toUpperCase(),
                limit: 1000
              },
              method: 'GET'
            });

          case 12:
            warranty = _context.sent;
            response.data.modules = modules.data.items;
            response.data.warranty = warranty.data.items;
            ctx.commit('item', response.data);
            return _context.abrupt("return", response);

          case 19:
            _context.prev = 19;
            _context.t0 = _context["catch"](1);
            return _context.abrupt("return", _context.t0);

          case 22:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 19]]);
  }));
  return _get.apply(this, arguments);
}

export function queryByMeasurements(_x2) {
  return _queryByMeasurements.apply(this, arguments);
}

function _queryByMeasurements() {
  _queryByMeasurements = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(ctx) {
    var queryParams,
        response,
        _args2 = arguments;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            queryParams = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};
            _context2.prev = 1;
            _context2.next = 4;
            return axiosInstance({
              url: '/tyres',
              params: queryParams,
              method: 'GET'
            });

          case 4:
            response = _context2.sent;
            ctx.commit('items', response.data.items);
            ctx.commit('pagination', response.data.pagination);
            _context2.next = 12;
            break;

          case 9:
            _context2.prev = 9;
            _context2.t0 = _context2["catch"](1);
            return _context2.abrupt("return", _context2.t0);

          case 12:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[1, 9]]);
  }));
  return _queryByMeasurements.apply(this, arguments);
}

export function query(_x3) {
  return _query.apply(this, arguments);
}

function _query() {
  _query = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(ctx) {
    var queryParams,
        response,
        _args3 = arguments;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            queryParams = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : {};
            _context3.prev = 1;
            _context3.next = 4;
            return axiosInstance({
              url: '/car-tyres',
              params: queryParams,
              method: 'GET'
            });

          case 4:
            response = _context3.sent;
            ctx.commit('items', response.data.items);
            ctx.commit('pagination', response.data.pagination);
            _context3.next = 12;
            break;

          case 9:
            _context3.prev = 9;
            _context3.t0 = _context3["catch"](1);
            return _context3.abrupt("return", _context3.t0);

          case 12:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[1, 9]]);
  }));
  return _query.apply(this, arguments);
}

function parseUrl(state, params) {
  if (state && params.id) {
    return '/' + state + '/' + params.id;
  }

  return '/' + state;
}